import { css } from 'emotion';

export const footer = css(`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 800px;
	margin: 0 auto;
	padding: 15px 0 80px 0;

	@media all and (max-width: 960px) {
		width: 100%;
	}
`);
